import { type Common } from './common.js';
import type * as HccFinding from './models/hccFinding.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  // analyst app endpoints
  async findHccFindingsToExportByEncounterId(
    encounterId: string
  ): Promise<HccFinding.HccFinding[]> {
    const url = this.common.constructPath(`/hcc-findings/findings-to-export`, {
      encounterId,
    });
    return await this.common.getJSON(url);
  }
}
